import SmallFence from "@components/Labels/SmallFence";
import { Fragment, type ReactNode } from "react";

const BranchName = ({ name }: { name: string }) => (
	<span className="inline-flex align-middle" title={name}>
		<SmallFence fixWidth overflow="hidden" value={name} />
	</span>
);

export const renderWithBranches = (template: string, branches: Record<string, string>): ReactNode => {
	const nodes: ReactNode[] = [];
	for (const part of template.split(/(\{\{\w+\}\})/)) {
		const name = part.startsWith("{{") ? branches[part.slice(2, -2)] : undefined;
		nodes.push(
			name === undefined ? (
				<Fragment key={nodes.length}>{part}</Fragment>
			) : (
				<BranchName key={nodes.length} name={name} />
			),
		);
	}
	return nodes;
};
